// src/components/Layout.jsx

import React from 'react';
import { Outlet } from 'react-router'; // This is from the library we installed
import { Header } from '../components/Header.jsx'; // Import the Header component
import { Footer } from '../components/Footer.jsx';
import '../App.css'; // Import your global styles

const Layout = () => {
  return (
    <div className="app-container">
      <div className="content">
        <Header /> {/* Render the Header component */}
        <main>
        {/* It's good practice to wrap the Outlet in a <main> tag */}
        <Outlet />
        <Footer /> {/* Render the Footer component */}
      </main>
      </div>
    </div>
  );
};

export default Layout;
